import defer from '../utils/defer';
/**
 * @ngdoc service
 * @name proximus.core.entity:EntityIdentifier
 * @description
 * # EntityIdentifier
 *  Provides common functions to manage entities in framework
 */
export default class EntityIdentifier {
    constructor(platformService) {
        this.platformService = platformService;
    }
    replaceUrlPlaceholders(url, parameterMap) {
        let processedUrl = url;
        if (processedUrl) {
            // replace mandatory url parameters
            if (parameterMap) {
                Object.keys(parameterMap).forEach(paramName => {
                    processedUrl = processedUrl.replace('{' + paramName + '}', parameterMap[paramName]);
                });
            }
            // build url for optional parameters if exists
            processedUrl = this._replaceOptionalParameters(processedUrl, '?', parameterMap);
            processedUrl = this._replaceOptionalParameters(processedUrl, '&', parameterMap);
            //remove unreplaced mandatory parameters if they are in query selector
            //to handle legacy code
            processedUrl = processedUrl.replace(/\{.*?\}/g, '');
        }
        return processedUrl;
    }
    getUniqueKey(entityConfig) {
        return entityConfig.rel + this.getEntityIdentifier(entityConfig);
    }
    shouldIncludeKey(entityConfig, key) {
        return entityConfig.uniqueIdentifier
            ? entityConfig.uniqueIdentifier === key
            : entityConfig.ignoredIdentifiers === undefined ||
                (entityConfig.ignoredIdentifiers && entityConfig.ignoredIdentifiers.indexOf(key) === -1);
    }
    getEntityIdentifier(entityConfig) {
        let identifier = entityConfig.version;
        if (entityConfig.parameters) {
            Object.keys(entityConfig.parameters).forEach(key => {
                if (this.shouldIncludeKey(entityConfig, key)) {
                    identifier += entityConfig.parameters[key];
                }
            });
        }
        return identifier;
    }
    addCustomerIdForPreviewMode(entity) {
        const deferred = defer();
        if (!this.platformService.isReactNative() &&
            entity.url &&
            this.platformService.isMagnoliaAuthor()) {
            const mockedUser = sessionStorage.getItem('mockedUser');
            if (mockedUser) {
                entity.url = entity.url.includes('?')
                    ? this._replacePrefixPath(entity.url, 'rest', 'rest_node') + '&mockedUser=' + mockedUser
                    : this._replacePrefixPath(entity.url, 'rest', 'rest_node') + '?mockedUser=' + mockedUser;
                deferred.resolve(entity);
            }
            else {
                deferred.resolve(entity);
            }
        }
        else {
            deferred.resolve(entity);
        }
        return deferred.promise;
    }
    _replaceOptionalParameters(processedUrl, type, parameterMap) {
        if (processedUrl.indexOf('{' + type) > 0) {
            const optionalParameters = processedUrl.substring(processedUrl.indexOf('{' + type) + 2, processedUrl.indexOf('}'));
            processedUrl = processedUrl.substring(0, processedUrl.indexOf('{' + type)) + type;
            const optionalParametersArray = optionalParameters.split(',');
            if (optionalParametersArray) {
                optionalParametersArray.forEach(optionalParameter => {
                    if (parameterMap && parameterMap[optionalParameter]) {
                        processedUrl += optionalParameter + '=' + parameterMap[optionalParameter] + '&';
                    }
                });
            }
            processedUrl = processedUrl.substring(0, processedUrl.length - 1);
        }
        return processedUrl;
    }
    _replacePrefixPath(url, currPrefix, newPrefix) {
        const urlArray = url.split('/');
        urlArray.forEach((attr, index) => {
            if (attr === currPrefix) {
                urlArray[index] = newPrefix;
            }
        });
        return urlArray.join('/');
    }
}
